import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidDubaiAppIcon,
  AndroidDubaiMultiIcon,
  AndroidDubaiSoftwareIcon,
  AndroidDubaiCustomIcon,
  AndroidDubaiSupportIcon,
  AndroidDubaiUItIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: AndroidDubaiAppIcon,
    title: "Android App Development",
    description:
      "We specialize in providing high-quality Android app development services in Dubai for phones and tablets. Our expert Android app developers in Dubai utilize innovative Android technology and tools to produce apps that are both user-friendly and technically complex. If you want to make an impression in the Dubai Android app market, we are your go-to bespoke mobile app development partner.",
  },
  {
    icon: AndroidDubaiMultiIcon,
    title: "Multi-Platform Deployment",
    description:
      "As a bespoke Android app development company, we specialize in smooth integration and deployment. Regardless of your selected platform, our skilled Android development services have been customized to your specific requirements. Whether you want to launch on Android, iOS, or cross-platform, we have the experience to bring you there fast and effectively. Our mobile application development guide provides a detailed overview of Android development.",
  },
  {
    icon: AndroidDubaiSoftwareIcon,
    title: "Android Software Testing",
    description:
      "Our Android mobile development prioritizes glitch-free experiences with flawless operation while ensuring top-tier security and excellent speed. Using a combination of manual and automated testing methods, we thoroughly examine every area of your Android application to ensure its future preparedness, providing users with an effortless experience with no lag.",
  },
  {
    icon: AndroidDubaiCustomIcon,
    title: "Custom Android Application Development",
    description:
      "With extensive experience, our Android application developers specialize in creating strong and scalable solutions for a wide range of industries throughout the world. We specialize in creating custom Android software that reflects your brand's distinct character in a broad marketplace of millions of apps. Allow us to assist you in developing a compelling solution that connects with your target audience and generates success.",
  },
  {
    icon: AndroidDubaiSupportIcon,
    title: "Android App Support and Maintenance",
    description:
      "Beyond the initial development process, our Dubai team offers extensive support and maintenance services for Android apps. We prioritize maintaining your software strong, updated, and in line with changing customer demands by including new features. With a proactive approach to Android app development in Dubai, we do monthly maintenance to quickly repair issues and upgrade your app with unique features, assuring continued quality and customer pleasure.",
  },
  {
    icon: AndroidDubaiUItIcon,
    title: "Android UI/UX Design",
    description:
      "We specialize in creating visually attractive Android UI/UX designs that increase user engagement and happiness. Our experienced designers thoroughly examine user behavior and industry trends to produce intuitive and aesthetically beautiful designs that reflect your business identity. Elevate your Android applications with our carefully produced UI/UX designs, guaranteeing that your customers have an outstanding user experience.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Revolutionize Your App Development in Dubai with TekRevol's
              Comprehensive Services
            </h2>
            <p className="impro_para">
              Our team uses the most recent Android app development frameworks
              to create solutions that change user experiences and promote
              company success in Dubai. You can rely on us as a competent
              Android app development company in Dubai to turn your ideas into
              effective, results-driven mobile apps. Here are the Android app
              development services in Dubai that TekRevol offers:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
